<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png"></van-col>
                    <van-col span="12">
                        <div class="banner-title">排行榜</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content-body">
            <van-tabs v-model="activeType" background="#000000" color="#20D38F" title-active-color="#20D38F"
                      title-inactive-color="#999999" line-width="20px" @click="getFriendsRank">
                <van-tab>
                    <template #title>
                        <div class="title">运动时长</div>
                    </template>
                </van-tab>
                <van-tab>
                    <template #title>
                        <div class="title">步数</div>
                    </template>
                </van-tab>
                <van-tab>
                    <template #title>
                        <div class="title">卡路里</div>
                    </template>
                </van-tab>
            </van-tabs>
            <div class="time-tabs">
                <div class="bar">
                    <div class="barTitle" :class="{ 'bar-active': activeTime == 0 }" @click="selectDay">日榜</div>
                    <div class="barTitle" :class="{ 'bar-active': activeTime == 1 }" @click="selectWeek">周榜</div>
                    <div class="barTitle" :class="{ 'bar-active': activeTime == 2 }" @click="selectMonth">月榜</div>
                </div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" src="@/assets/share/sportRank/left.png">
                <div class="time-date">{{time}}</div>
                <img @click="timeRight" class="time-icon" src="@/assets/share/sportRank/right.png">
            </div>
            <div class="user-rank">
                <div>
                    <div class="rank-item rank-item-two" id="twoBox" @click="toFriendDesc(rankList[1].userId)">
                        <div class="two-box">
                            <img class="rank-medal" src="@/assets/share/sportRank/two.png">
                            <img class="rank-two" :src="rankList[1].userAvatar ? rankList[1].userAvatar : defaultImg">
                        </div>
                        <div class="user-name" :class="{ 'me': rankList[1].userName == '我' }"
                             style="margin-top: 6px; position: absolute">{{rankList[1].userName}}
                        </div>
                    </div>
                    <div class="rank-item rank-item-one" @click="toFriendDesc(rankList[0].userId)">
                        <div class="one-box">
                            <img class="medal-one" src="@/assets/share/sportRank/one.png">
                            <img class="rank-one" :src="rankList[0].userAvatar ? rankList[0].userAvatar : defaultImg">
                        </div>
                        <div class="user-name" :class="{ 'me': rankList[0].userName == '我' }" style="margin-top: 6px;">
                            {{rankList[0].userName}}
                        </div>
                    </div>
                    <div class="rank-item rank-item-three" id="threeBox" v-if="rankList.length > 2"
                         @click="toFriendDesc(rankList[2].userId)">
                        <div class="three-box">
                            <img class="medal-three" src="@/assets/share/sportRank/three.png">
                            <img class="rank-three" :src="rankList[2].userAvatar ? rankList[2].userAvatar : defaultImg">
                        </div>
                        <div class="user-name" :class="{ 'me': rankList[2].userName == '我' }"
                             style="margin-top: 6px; position: absolute">{{rankList[2].userName}}
                        </div>
                    </div>
                    <div class="rank-item rank-item-three" v-if="rankList.length < 3">
                        <div class="three-box">
                            <img class="medal-three" src="@/assets/share/sportRank/three.png">
                            <img class="rank-three" src="@/assets/share/sportRank/no.png">
                        </div>
                        <div class="user-name"
                             style="margin-top: 6px; position: absolute">--
                        </div>
                    </div>
                </div>
                <div class="rank-vaule">
                    <img class="rank-bg" src="@/assets/share/sportRank/rankBg.png">
                </div>
                <div class="rank-num-box">
                    <div class="rank-item value2">{{dealTotal(rankList[1].total)}}</div>
                    <div class="rank-item value1">{{dealTotal(rankList[0].total)}}</div>
                    <div class="rank-item value3" v-if="rankList.length > 2">{{dealTotal(rankList[2].total)}}</div>
                    <div class="rank-item value3" v-if="rankList.length < 3"></div>
                </div>
                <div class="other-box">
                    <div class="nap"></div>
                    <div class="other-item-box">
                        <div class="other-title">
                            <van-row>
                                <van-col span="8">排名</van-col>
                                <van-col span="8">
                                    <div class="title-user">用户昵称</div>
                                </van-col>
                                <van-col span="8">{{activeType == 0 ? '运动时长' : activeType == 1 ? '总步数' : '卡路里'}}
                                </van-col>
                            </van-row>
                        </div>
                        <div class="other-item">
                            <div class="no-rank" v-if="rankList.length < 4">
                                后续排名空缺，快邀请更多好友加入~
                            </div>
                            <div class="item" @click="toFriendDesc(item.userId)" :class="{ 'me': item.userName == '我' }"
                                 v-for="(item, index) in rankList"
                                 v-if="index > 2">
                                <van-row>
                                    <van-col span="8">{{item.rank ? item.rank : '- -'}}</van-col>
                                    <van-col span="8">
                                        <div class="title-user">
                                            <img class="item-icon"
                                                 :src="item.userAvatar ? item.userAvatar : defaultImg">
                                            <div class="user-name user-name-hou">{{item.userName}}</div>
                                        </div>
                                    </van-col>
                                    <van-col span="8">{{dealTotal(item.total)}}</van-col>
                                </van-row>
                            </div>
                        </div>
                    </div>
                    <div class="nap-bottom"></div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {
        getToday,
        getNWeekFirstDay,
        getNWeekLastDay,
        getMonthStartDay,
        getMonthEndDay,
        GetDateStr, SwitchTime24
    } from "../../utils/dateUtils";

    export default {
        name: 'sportRank',
        data() {
            return {
                defaultImg: require('@/assets/share/home/noImg.png'),
                activeType: 1,
                activeTime: 0,
                time: getToday().slice(5, 10).replace(/-/g, '/'),
                startDate: getToday(),
                endDate: getToday(),
                tNum: 0,
                wNum: 0,
                mNum: 0,
                rankList: [],
            }
        },
        mounted() {
            this.getFriendsRank();
        },
        methods: {
            back() {
                this.$router.back();
            },
            selectDay() {
                this.activeTime = 0;
                this.startDate = getToday();
                this.endDate = getToday();
                this.time = getToday().slice(5, 10).replace(/-/g, '/');
                this.getFriendsRank();
            },
            selectWeek() {
                this.activeTime = 1;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                this.getFriendsRank();
            },
            selectMonth() {
                this.activeTime = 2;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = this.startDate.slice(0, 7).slice(5, 10).replace(/-/g, '/');
                this.getFriendsRank();
            },
            getFriendsRank() {
                this.rankList = [];
                let type;
                if (this.activeType == 0) {
                    type = 'actTime';
                } else if (this.activeType == 1) {
                    type = 'step';
                } else {
                    type = 'calorie';
                }
                this.$api.share.getFriendsRank({
                    startDate: this.startDate,
                    endDate: this.endDate + ' 23:59:59',
                    type
                }).then(res => {
                    this.rankList = res.info;
                })
            },
            timeLeft() {
                if (this.activeTime == 0) {
                    this.tNum++;
                    this.startDate = GetDateStr(this.tNum);
                    this.endDate = GetDateStr(this.tNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1) {
                    this.wNum--;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 2) {
                    this.mNum--;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = this.startDate.slice(0, 7).slice(5, 10).replace(/-/g, '/');
                }
                this.getFriendsRank();
            },
            timeRight() {
                if (this.activeTime == 0 && this.tNum > 0) {
                    this.tNum--;
                    this.startDate = GetDateStr(this.tNum);
                    this.endDate = GetDateStr(this.tNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
                    this.getFriendsRank();
                } else if (this.activeTime == 1 && this.wNum < 0) {
                    this.wNum++;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                    this.getFriendsRank();
                } else if (this.activeTime == 2 && this.mNum < 0) {
                    this.mNum++;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = this.startDate.slice(0, 7).slice(5, 10).replace(/-/g, '/');
                    this.getFriendsRank();
                }
            },
            dealTotal(value) {
                if (!value) {
                    return '- -'
                }
                if (this.activeType == 0) {
                    value = SwitchTime24(value);
                } else if (this.activeType == 2) {
                    value = value / 1000;
                    if (/[\.]/.test(value)) {
                        value = value.toFixed(1)
                    }
                } else {
                    value = value;
                }
                return value
            },
            toFriendDesc(userId) {
                if (userId != localStorage.getItem("userId")) {
                    localStorage.setItem("sharerId", userId);
                    this.$router.push({
                        name: 'friendDesc'
                    })
                }
            },
        }
    }
</script>

<style scoped>
    @import "../../assets/font/font.css";

    /deep/ .van-tabs__wrap {
        width: 100%;
    }

    .title {
        font-size: 15px;
    }

    .bar {
        text-align: center;
    }

    .barTitle {
        width: 60px;
        text-align: center;
        display: inline-block;
        margin: 20px 12px 5px 12px;
        padding-top: 3px;
        padding-bottom: 5px;
        background-color: #202020;
        border-radius: 50px;
        font-size: 14px;
        color: #A5A5A5;
    }

    .bar-active {
        position: relative;
        color: #ffffff;
        background-color: #20D38F;
    }

    .time-select {
        text-align: center;
        margin-top: 10px;
    }

    .time-icon {
        width: 8px;
    }

    .time-date {
        display: inline-block;
        width: 201px;
        vertical-align: middle;
        font-size: 15px;
    }

    .user-rank {
        margin-top: 30px;
        width: 100%;
        font-size: 0;
        text-align: center;
    }

    .rank-item {
        position: relative;
        display: inline-block;
        text-align: center;
    }

    .rank-item-two {
        width: 25%;
    }

    .two-box {
        position: relative;
        width: 60px;
        height: 60px;
        text-align: center;
        margin: 0px auto;
    }

    .rank-two {
        border: 2px solid #65D1FF;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-bottom: 10px;
    }

    .rank-medal {
        position: absolute;
        width: 37px;
        right: -9px;
        top: -20px;
        z-index: -1;
    }

    .rank-item-one {
        width: 30%;
    }

    .one-box {
        position: relative;
        width: 80px;
        height: 80px;
        text-align: center;
        margin: 0 auto;
    }

    .rank-one {
        border: 2px solid #FF991F;
        width: 80px;
        height: 80px;
        border-radius: 50%;
    }

    .medal-one {
        position: absolute;
        width: 50px;
        right: -12px;
        top: -28px;
        z-index: -1;
    }

    .rank-item-three {
        width: 25%;
        height: 50px;
    }

    .rank-three {
        border: 2px solid #53FFBF;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-bottom: 0px;
    }

    .medal-three {
        position: absolute;
        width: 37px;
        right: -12px;
        top: -20px;
        z-index: -1;
    }

    .three-box {
        position: relative;
        width: 50px;
        height: 50px;
        text-align: center;
        margin: 0px auto;
    }

    .user-name {
        font-size: 14px !important;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        text-align: center;
        width: 100%;
        font-family: "微软雅黑";
        line-height: 20px;
    }

    .rank-vaule {
        width: 297px;
        height: 91px;
        margin: 10px auto;
        position: relative;
    }

    .rank-bg {
        width: 297px;
        height: 91px;
    }


    .rank-num-box {
        color: #000000;
        z-index: 111;
        width: 85%;
        margin: -40px auto;
        height: 36px;
    }

    .rank-num-box div {
        font-family: SemiBoldItalic;
    }

    .value1 {
        font-size: 24px;
        width: 33%;
    }

    .value2 {
        font-size: 20px;
        width: 33%;
    }

    .value3 {
        font-size: 20px;
        width: 33%;
    }

    .other-box {
        width: 96%;
        margin: 18px auto;
        background: linear-gradient(133deg, #86DBE8 0%, #C2E7FF 38%, #98CFFF 63%, #AAF6FF 85%, #ADF5C0 100%);
        border-radius: 6px 6px 6px 6px;
    }

    .other-item-box {
        width: 96%;
        margin: 0 auto;
        background: #202020;
        border-radius: 6px 6px 6px 6px;
        padding-top: 15px;
        min-height: 100px;
    }

    .nap {
        width: 100%;
        height: 16px;
    }

    .nap-bottom {
        width: 100%;
        height: 8px;
    }

    .title-rank {
        width: 25%;
        display: inline-block;
    }

    .title-user {
        text-align: left;
    }

    .title-vaule {
        width: 30%;
        display: inline-block;
    }

    .other-title {
        color: #989898;
        font-size: 14px;
        margin-bottom: 15px;
    }

    .item {
        font-family: SemiBoldItalic;
        font-size: 17px;
        padding-bottom: 15px;
    }

    .item-icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        vertical-align: inherit;
        margin-right: 5px;
        margin-left: -5px;
    }

    .me {
        color: #20D38F !important;
    }

    .no-rank {
        text-align: center;
        font-size: 14px;
        margin: 28px auto;
    }

    .user-name-hou {
        max-width: 80px;
        display: inline-block;
        line-height: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/views/share/sportRank.vue